var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.92 23.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003189;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6125",
    "data-name": "Group 6125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    className: "cls-1",
    d: "M5.21,1.62v-.91c-.04-.35.21-.66.55-.7s.66.21.7.55c0,.05,0,.1,0,.15v.9h8.99v-.92c-.03-.34.23-.65.58-.67.34-.03.65.23.67.58,0,.02,0,.04,0,.06.01.31,0,.63,0,.97h2.25c.28,0,.56.01.83.06,1.17.23,2.04,1.22,2.11,2.41,0,.12.02.24.02.36v16.26c.08,1.08-.52,2.1-1.5,2.55-.36.17-.75.26-1.15.26-5.54.02-11.08.02-16.61,0-1.43.03-2.61-1.1-2.65-2.53,0-.04,0-.08,0-.12C0,15.35,0,9.82,0,4.29-.02,2.85,1.12,1.65,2.57,1.62c.06,0,.12,0,.18,0,.7-.01,1.41,0,2.11,0h.34ZM1.26,7.32c0,.11-.01.19-.01.27v13.16c-.06.78.52,1.47,1.3,1.54.08,0,.17,0,.25,0h16.3c.78.08,1.48-.49,1.57-1.27.01-.1.01-.2,0-.3V7.32H1.26ZM5.21,2.88c-.94,0-1.83-.03-2.73.01-.59.03-1.08.47-1.17,1.06-.06.69-.02,1.38-.02,2.08h19.38c0-.6,0-1.17,0-1.74,0-.77-.61-1.41-1.38-1.42-.02,0-.04,0-.05,0h-2.52v.97c0,.35-.27.63-.61.64-.05,0-.1,0-.15-.02-.3-.07-.5-.36-.48-.67,0-.3,0-.61,0-.92H6.47v.88c0,.45-.25.72-.64.71-.35,0-.63-.3-.62-.65,0-.02,0-.04,0-.06-.01-.28,0-.57,0-.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7131",
    "data-name": "Path 7131",
    className: "cls-1",
    d: "M5.03,15.73h1.56c.34-.04.65.2.7.54,0,.04,0,.09,0,.13,0,1.06,0,2.12,0,3.17.03.34-.21.64-.55.67-.04,0-.08,0-.13,0-1.06,0-2.12,0-3.17,0-.34.04-.65-.2-.69-.54,0-.05,0-.1,0-.15,0-1.05,0-2.1,0-3.15-.04-.34.21-.65.55-.69.05,0,.09,0,.14,0,.53,0,1.06,0,1.59,0ZM6.02,19.01v-2.01h-1.99v2.01h1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7132",
    "data-name": "Path 7132",
    className: "cls-1",
    d: "M16.83,15.73h1.56c.34-.05.66.19.71.53,0,.05,0,.11,0,.16,0,1.05,0,2.1,0,3.15.04.34-.21.65-.55.69-.05,0-.1,0-.15,0-1.05,0-2.1,0-3.15,0-.34.04-.66-.2-.7-.55,0-.05,0-.11,0-.16,0-1.04,0-2.08,0-3.12-.04-.34.2-.66.55-.7.05,0,.11,0,.16,0,.52,0,1.04,0,1.56,0ZM17.83,19.01v-2.01h-1.99v2.01h1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    className: "cls-1",
    d: "M5.03,9.27h1.58c.34-.03.65.21.68.55,0,.04,0,.08,0,.12,0,1.07,0,2.13,0,3.2.03.34-.22.63-.56.66-.04,0-.07,0-.11,0-1.07,0-2.15,0-3.22,0-.34.02-.63-.23-.65-.56,0-.04,0-.07,0-.11,0-1.07,0-2.13,0-3.2-.03-.34.23-.63.57-.66.03,0,.06,0,.1,0,.54,0,1.07,0,1.61,0ZM4.03,10.53v2.02h1.99v-2.02h-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    className: "cls-1",
    d: "M16.84,9.27h1.56c.35-.04.66.2.71.55,0,.05,0,.1,0,.15,0,1.04,0,2.08,0,3.11.05.34-.19.66-.53.71-.06,0-.11,0-.17,0-1.05,0-2.09,0-3.14,0-.48,0-.71-.24-.71-.73,0-1.03,0-2.06,0-3.09-.05-.35.2-.67.55-.72.06,0,.12,0,.18,0,.52,0,1.04,0,1.56,0ZM15.83,12.55h2v-2.02h-2v2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    className: "cls-1",
    d: "M10.91,9.27h1.56c.34-.05.65.18.7.52,0,.06,0,.12,0,.18,0,1.04,0,2.08,0,3.12,0,.48-.22.71-.7.71-1.05,0-2.1,0-3.14,0-.47,0-.69-.24-.69-.72v-3.09c0-.5.22-.72.74-.72s1.03,0,1.54,0ZM11.91,10.51c-.64,0-1.27,0-1.9,0-.06.02-.11.07-.13.13,0,.63,0,1.25,0,1.89h2.03v-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-1",
    d: "M8.64,17.98v-1.59c-.04-.33.19-.63.52-.67.05,0,.1,0,.15,0,1.06,0,2.11,0,3.17,0,.33-.04.63.19.67.51,0,.05,0,.1,0,.16,0,1.06,0,2.11,0,3.17.04.33-.19.64-.52.68-.06,0-.11,0-.17,0-1.05,0-2.1,0-3.14,0-.47,0-.69-.23-.69-.71,0-.52,0-1.04,0-1.56ZM11.91,16.97c-.64,0-1.27,0-1.9,0-.06.02-.11.07-.13.13,0,.63,0,1.25,0,1.89h2.03v-2.03Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.e20c1463599450a1cc6530f0345b4032.svg";
export { ForwardRef as ReactComponent };